var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWidgetOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2739",
    "data-name": "\\uADF8\\uB8F9 2739",
    transform: "translate(-14139 -7222)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2001",
    "data-name": "\\uC0AC\\uAC01\\uD615 2001",
    width: 8,
    height: 6,
    rx: 2,
    transform: "translate(14139 7222)",
    fill: "#2ee3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2003",
    "data-name": "\\uC0AC\\uAC01\\uD615 2003",
    width: 8,
    height: 6,
    rx: 2,
    transform: "translate(14157 7240) rotate(180)",
    fill: "#2ee3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2002",
    "data-name": "\\uC0AC\\uAC01\\uD615 2002",
    width: 8,
    height: 11,
    rx: 2,
    transform: "translate(14139 7229)",
    fill: "#008aff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2004",
    "data-name": "\\uC0AC\\uAC01\\uD615 2004",
    width: 8,
    height: 11,
    rx: 2,
    transform: "translate(14157 7233) rotate(180)",
    fill: "#008aff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetOpen);
export default __webpack_public_path__ + "static/media/widget_open.123ebbbd1c87de7c2f32d24232da03e5.svg";
export { ForwardRef as ReactComponent };